import { v4 as uuidv4 } from "uuid";
export class EmployeesGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.employeeId = "";
        this.fullName = "";
    }
}
export default class EmployeesGridView extends EmployeesGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
